module.exports = __webpack_public_path__ + "img/icon-13.ecc1f732.png";